import React from 'react';
import { useQuery } from '@apollo/client';
import { GET_MY_SCOPE_TYPES } from '../../gql/auth';
import PropTypes from 'prop-types';
import { containsOneOf } from '../../utils';
import { Spin } from 'antd';

/**
 *
 * @param {[string]} expectedScopeType - show children if contains one of the expected scope types
 * @returns
 */
const PrivateComponent = ({ expectedScopeType, children, renderDenied }) => {
  const hasExpectedScopeType = containsOneOf(expectedScopeType);
  const { data, loading } = useQuery(GET_MY_SCOPE_TYPES, {
    // fetchPolicy: 'cache-and-network',
  });

  return (
    <Spin spinning={loading} delay={300}>
      {data?.myScopeTypes &&
      (hasExpectedScopeType(data.myScopeTypes) ||
        expectedScopeType.length === 0) ? (
        <>{children}</>
      ) : (
        renderDenied
      )}
    </Spin>
  );
  // if (
  //   !loading &&
  //   data.myScopeTypes &&
  //   (hasExpectedScopeType(data.myScopeTypes) || expectedScopeType.length === 0)
  // ) {
  //   return <>{children}</>;
  // } else {
  //   return renderDenied;
  // }
};

PrivateComponent.defaultProps = {
  expectedScopeType: [],
  renderDenied: <></>,
};

PrivateComponent.propTypes = {
  expectedScopeType: PropTypes.array.isRequired,
  renderDenied: PropTypes.node.isRequired,
};

export default PrivateComponent;
